export const creativesLinks = {
    creatives: () => '/creatives',
    topPreview: () => '/top-preview'
};
